export default __webpack_public_path__ + "static/media/DSC_0798.fcb145c8.jpg";